export const imgPathReplace = (url: string): string => {
  const httpsPosition = url?.indexOf("https://amityonline.com");
  if(process.env.NEXT_PUBLIC_NEW_IMAGE_PATH){
    if (httpsPosition === 0) {
      return process.env.NEXT_PUBLIC_NEW_IMAGE_PATH + url?.slice(24);
    }
  }
  return url;
  }
